var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6803_42283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2667 8H23.6C23.0667 8 22.6667 7.6 22.6667 6.93333C22.6667 5.33333 21.3333 4 19.7333 4H12.2667C10.6667 4 9.33333 5.33333 9.33333 6.93333C9.33333 7.6 8.93333 8 8.26667 8H3.73333C1.6 8 0 9.6 0 11.7333V24.4C0 26.4 1.6 28 3.73333 28H28.4C30.4 28 32.1333 26.4 32.1333 24.2667V11.7333C32 9.6 30.4 8 28.2667 8ZM16 24C12.6667 24 10 21.3333 10 18C10 14.6667 12.6667 12 16 12C19.3333 12 22 14.6667 22 18C22 21.3333 19.3333 24 16 24Z",
    fill: "#ECEDEE",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6803_42283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImage);
export default __webpack_public_path__ + "static/media/user_image.af71302e78a7ce8d5dcd46f436a6a571.svg";
export { ForwardRef as ReactComponent };